import { useFieldDescribedBy } from '@/components/sui/field'
import {
  InputOTP as BaseInputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from '@/components/ui/input-otp'
import { cn } from '@/lib/utils'

function InputOTP({
  containerClassName,
  'aria-describedby': ariaDescribedBy,
  ...props
}: React.ComponentProps<typeof BaseInputOTP>) {
  const describedBy = useFieldDescribedBy(ariaDescribedBy)
  return (
    <BaseInputOTP
      aria-describedby={describedBy}
      containerClassName={cn(
        '[&>div:last-child]:overflow-clip',
        containerClassName,
      )}
      {...props}
    />
  )
}

export { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot }
